import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/ag06modification/attach.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/ag06modification/backside.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/ag06modification/drillahole.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/ag06modification/magsafe.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/ag06modification/overview.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/ag06modification/unscrew.jpg");
